<template>
	<div
		style="width: 95%"
		class="ml-5"
	>
		<loading-overlay
			:active="isLoading"
			:can-cancel="true"
		/>
		<b-modal
			id="bv-modal"
			ref="image-modal"
			hide-footer
		>
			<template #modal-title>
				Create New PDP Image
			</template>
			<div
				v-if="spinner"
				class="text-center"
			>
				<div
					class="spinner-grow text-primary m-5"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
			</div>
			<div v-else>
				<b-form-group
					label="Language"
					label-for="example-select"
					label-cols-lg="3"
				>
					<b-input-group>
						<custom-select
							id="example-select"
							v-model="langid"
							plain
						>
							<b-form-select-option :value="null">
								Please select an option
							</b-form-select-option>
							<b-form-select-option
								v-for="(lang) in language "
								:key="lang.id"
								:value="lang.id"
							>
								{{ lang.id }} | {{ lang.name }}
							</b-form-select-option>
						</custom-select>
						<template #append>
							<b-input-group-text
								class="input-group-text-alt"
								style="cursor:pointer"
							>
								<custom-checkbox
									id="checkbox-1"
									name="checkbox-1"
									:checked="langid === null"
									unchecked-value="not_accepted"
									@change="()=> langid = null "
								/>
								Null
							</b-input-group-text>
						</template>
					</b-input-group>
				</b-form-group>

				<b-form-group
					label="Image"
					label-cols-lg="3"
				>
					<Field
						v-slot="{ errors }"
						rules="image"
						name="Image"
					>
						<div
							class="control"
						>
							<custom-file-input
								id="image"
								ref="image"
								v-model="url"
								:placeholder="placeHolders.thumbnailPlaceholder"
								@click="updateImagePreview"
							/>
							<span>{{ errors[0] }}</span>
						</div>
					</Field>

					<div
						v-if="imagePreview"
						class="thumbnail"
					>
						<img
							:src="imagePreview"
							alt=""
							srcset=""
							height="100"
							width="100"
						>
						<div
							style="cursor:pointer"
							@click="removeImage"
						>
							&#10006; Remove
						</div>
					</div>
				</b-form-group>
				<b-form-group
					class="form-group"
					label="width "
					label-for="block-form1-name"
					label-cols-lg="3"
				>
					<Field
						v-slot="{ errors }"
						v-model="width"
						rules="integer"
						name="Width"
					>
						<div
							class="control"
						>
							<b-form-input
								ref="pdpImageName"
								v-model="width"
								type="text"
								:disabled="width === null ? true : false"
							/>
							<span>{{ errors[0] }}</span>
						</div>
					</Field>
				</b-form-group>
				<b-form-group
					class="form-group"
					label="height: "
					label-for="block-form1-name"
					label-cols-lg="3"
				>
					<Field
						v-slot="{ errors }"
						v-model="height"
						rules="integer"
						name="Height"
					>
						<div
							class="control"
						>
							<b-form-input
								ref="pdpImageName"
								v-model="height"
								type="text"
								:disabled="height === null ? true : false"
							/>
							<span>{{ errors[0] }}</span>
						</div>
					</Field>
				</b-form-group>
				<b-button
					class="mt-3"
					block
					@click="addPdpImage"
				>
					Save
				</b-button>
			</div>
		</b-modal>

		<b-modal
			id="bv-edit-modal"
			ref="image-edit-modal"
			hide-footer
		>
			<template #modal-title>
				Edit PDP Image
			</template>
			<div
				v-if="spinner"
				class="text-center"
			>
				<div
					class="spinner-grow text-primary m-5"
					role="status"
				>
					<span class="sr-only">Loading...</span>
				</div>
			</div>
			<div v-else>
				<b-form-group
					label="Language"
					label-for="example-select"
					label-cols-lg="5"
				>
					<b-input-group>
						<custom-select
							id="example-select"
							v-model="editModalItems.languageid"
							plain
						>
							<b-form-select-option
								v-for="(lang,id) in language "
								:key="id"
								:value="lang.id"
							>
								{{ lang.id }} | {{ lang.name }}
							</b-form-select-option>
						</custom-select>
						<template #append>
							<b-input-group-text
								class="input-group-text-alt"
								style="cursor:pointer"
							>
								<custom-checkbox
									id="checkbox-2"
									name="checkbox-1"
									:checked="editModalItems.languageid == null ? true : false"
									unchecked-value="not_accepted"
									@change="()=> editModalItems.languageid = null "
								/>
								Null
							</b-input-group-text>
						</template>
					</b-input-group>
				</b-form-group>

				<b-form-group
					label="Image"
					label-cols-lg="5"
				>
					<Field
						v-slot="{ errors }"
						rules="integer"
						name="Height"
					>
						<div
							class="control"
						>
							<custom-file-input
								id="editImage"
								ref="editImage"
								v-model="editModalItems.url"
								:placeholder="placeHolders.editImagePlaceholder"
								@click.prevent="editImagePreview"
							/>
							<span>{{ errors[0] }}</span>
						</div>
					</Field>

					<div
						v-if="editModalItems.url"
						class="thumbnail"
					>
						<img
							:src="editModalItems.url"
							alt=""
							srcset=""
							height="100"
							width="100"
						>
						<div
							style="cursor:pointer"
							@click="removeEditImage"
						>
							&#10006; Remove
						</div>
					</div>
				</b-form-group>
				<b-form-group
					class="form-group"
					label="width "
					label-for="block-form1-name"
					label-cols-lg="5"
				>
					<Field
						v-slot="{ field, errors }"
						v-model="editModalItems.width"
						rules="integer"
						name="width"
					>
						<div
							class="control"
						>
							<b-form-input
								ref="pdpImageName"
								v-bind="field"
								type="text"
								:disabled="editModalItems.width === null ? true : false"
							/>
							<span>{{ errors[0] }}</span>
						</div>
					</Field>
				</b-form-group>
				<b-form-group
					class="form-group"
					label="height: "
					label-for="block-form1-name"
					label-cols-lg="5"
				>
					<Field
						v-slot="{ field, errors }"
						v-model="editModalItems.height"
						rules="integer"
						name="Height"
					>
						<div
							class="control"
						>
							<b-form-input
								ref="pdpImageName"
								v-bind="field"
								type="text"
								:disabled="editModalItems.height === null ? true : false"
							/>
							<span>{{ errors[0] }}</span>
						</div>
					</Field>
				</b-form-group>
				<b-button
					class="mt-3"
					block
					@click="editPdpImage()"
				>
					Save
				</b-button>
			</div>
		</b-modal>
		<b-row
			style="width: 95%"
			class="ml-5"
		>
			<b-col
				md="5"
				lg="5"
				sm="12"
			>
				<base-block
					title="PDP properties"
					header-bg
				>
					<div
						v-if="loaded"
						class="text-center"
					>
						<div
							class="spinner-grow text-primary m-5"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
					</div>
					<div
						v-else
						class="d-block text-center"
					>
						<b-form-group
							class="form-group"
							label="Name: "
							label-for="block-form1-name"
							label-cols-lg="3"
						>
							<div
								class="control"
							>
								<b-form-input
									ref="pdpImageName"
									v-model="singlePdp.name"
									type="text"
								/>
							</div>
						</b-form-group>

						<b-form-group
							label="Add offering Image:"
							label-class="font-w600"
							label-cols-lg="5"
						>
							<custom-checkbox
								id="checkbox-3"
								ref="pdpImageOfferingImage"
								:is-switch="true"
								size="lg"
								:checked="singlePdp.addOfferingImage === 1 ? true : false"
								@change="singlePdp.addOfferingImage = $event"
							/>
						</b-form-group>
					</div>
				</base-block>
			</b-col>

			<b-col
				md="7"
				lg="7"
				sm="12"
			>
				<base-block
					title="PDP Images"
					header-bg
				>
					<b-row
						class="d-flex justify-content-end"
					>
						<b-col
							md="6"
							class="d-flex justify-content-end mb-2"
						>
							<router-link
								to="#"
								@click="showImageModal"
							>
								Add Image
							</router-link>
						</b-col>
					</b-row>
					<div
						ref="pdpImage"
					/>
				</base-block>
			</b-col>
		</b-row>
	</div>
</template>

<style scoped>
.thumbnail{
	display:flex;
	justify-content:space-around;
	align-items:Center;
	background-color: #ccc;
	margin-top:10px;
}
</style>

<style lang="scss">
@import "../../assets/scss/custom/errors";
</style>
